import carlosImg from "../assets/carlos.svg";
import jasmineImg from "../assets/jasmine.svg";
import emilyImg from "../assets/emily.svg";
import michaelImg from "../assets/michael.svg";
import davidImg from "../assets/david.svg";

// cash section
import icon_img_1 from "../assets/home/HourglassLine.svg";
import icon_img_2 from "../assets/home/CardTransfer.svg";
import icon_img_3 from "../assets/home/Clipboard.svg";
import icon_img_4 from "../assets/home/WalletMoney.svg";
import icon_img_5 from "../assets/home/Notes.svg";

// benefits choosing
import bc_img_1 from "../assets/home/Eye.svg";
import bc_img_2 from "../assets/home/Dialog.svg";
import bc_img_3 from "../assets/home/Rocket.svg";
import bc_img_4 from "../assets/home/ShieldCheck.svg";

// how it works
import hiwork_1 from "../assets/home/hitworks_1.png";
import hiwork_2 from "../assets/home/hitworks_2.png";
import hiwork_3 from "../assets/home/hitworks_3.png";
import hiwork_4 from "../assets/home/hitworks_4.png";

import mariaIcon from "../assets/home/maria.svg";

export const testimonialData = [
  {
    desc: "testimonial-desc1",
    user_name: "Carlos",
    user_from: "testimonial-from1",
    user_img: carlosImg,
  },
  {
    desc: "testimonial-desc2",
    user_name: "Jasmine",
    user_from: "testimonial-from2",
    user_img: jasmineImg,
  },
  {
    desc: "testimonial-desc3",
    user_name: "Emily",
    user_from: "testimonial-from3",
    user_img: emilyImg,
  },
  {
    desc: "testimonial-desc4",
    user_name: "Michael",
    user_from: "testimonial-from4",
    user_img: michaelImg,
  },
  {
    desc: "testimonial-desc5",
    user_name: "David",
    user_from: "testimonial-from5",
    user_img: davidImg,
  },
];

export const successStoriesData = [
  {
    desc: "success-section.desc1",
    user_name: "Maria S",
    owner: "success-section.owner1",
    opening_date: "success-section.opening1",
    rating: 4.9,
    user_img: mariaIcon,
  },
  {
    desc: "success-section.desc2",
    user_name: "Michael",
    owner: "success-section.owner2",
    opening_date: "success-section.opening2",
    rating: 4.5,
    user_img: michaelImg,
  },
  {
    desc: "success-section.desc3",
    user_name: "David",
    owner: "success-section.owner3",
    opening_date: "success-section.opening3",
    rating: 4.0,
    user_img: davidImg,
  },
];

export const cashAdvanceData = [
  {
    img: icon_img_1,
    titleKey: "cashAdvance.title1",
    descKey: "cashAdvance.desc1",
  },
  {
    img: icon_img_2,
    titleKey: "cashAdvance.title2",
    descKey: "cashAdvance.desc2",
  },
  {
    img: icon_img_3,
    titleKey: "cashAdvance.title3",
    descKey: "cashAdvance.desc3",
  },
  {
    img: icon_img_4,
    titleKey: "cashAdvance.title4",
    descKey: "cashAdvance.desc4",
  },
  {
    img: icon_img_5,
    titleKey: "cashAdvance.title5",
    descKey: "cashAdvance.desc5",
  },
];

export const benefitsChoosingData = [
  {
    img: bc_img_1,
    title: "benefits-section.title1",
    desc: "benefits-section.desc1",
  },
  {
    img: bc_img_2,
    title: "benefits-section.title2",
    desc: "benefits-section.desc2",
  },
  {
    img: bc_img_3,
    title: "benefits-section.title3",
    desc: "benefits-section.desc3",
  },
  {
    img: bc_img_4,
    title: "benefits-section.title4",
    desc: "benefits-section.desc4",
  },
];

export const howitWorksData = [
  {
    count: 1,
    title: "how-works.title1",
    desc: "how-works.desc1",
    img: hiwork_1,
  },
  {
    count: 2,
    title: "how-works.title2",
    desc: "how-works.desc2",
    img: hiwork_2,
  },
  {
    count: 3,
    title: "how-works.title3",
    desc: "how-works.desc3",
    img: hiwork_3,
  },
  {
    count: 4,
    title: "how-works.title4",
    desc: "how-works.desc4",
    img: hiwork_4,
    applynow: "btn-apply",
  },
];

export const AccordinData = [
  {
    title: "faq-title1",
    desc: "faq-desc1",
  },
  {
    title: "faq-title2",
    desc: "faq-desc2",
  },
  {
    title: "faq-title3",
    desc: "faq-desc3",
  },
  {
    title: "faq-title4",
    desc: "faq-desc4",
  },

  {
    title: "faq-title5",
    desc: "faq-desc5",
  },
  {
    title: "faq-title6",
    desc: "faq-desc6",
  },
  {
    title: "faq-title7",
    desc: "faq-desc7",
  },
  {
    title: "faq-title8",
    desc: "faq-desc8",
  },
  {
    title: "faq-title9",
    desc: "faq-desc9",
  },
];
